<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<!-- <div class="user-profile" style="background: url(assets/images/background/user-info.jpg) no-repeat;"> -->
<div class="user-profile">
  <!-- User profile image -->
  <!-- <div class="profile-img">
      <mat-icon style="font-size: 50px; color:white;fill:white">{{userIcon}}</mat-icon>
      <img src="assets/images/users/profile.png" alt="user">
  </div> -->
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile"
       [matTooltipClass]="'sidebar-email-tooltip'"
       class="ellipsis-text"
       matTooltip="{{ getUsername() }}">
      {{ getUsername() }}
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <button (click)="authService.logout()" mat-menu-item>
      <mat-icon>power_settings_new</mat-icon>
      Logout
    </button>
    <button [matMenuTriggerFor]="languages" mat-menu-item>
      <mat-icon>language</mat-icon>
      {{ 'sidemenu.languages' | translate }}
    </button>
  </mat-menu>

  <mat-menu #languages="matMenu">
    <button (click)="setLanguage('de')" mat-menu-item>
      Deutsch
    </button>
    <button (click)="setLanguage('en')" mat-menu-item>
      English
    </button>
    <button (click)="setLanguage('fr')" mat-menu-item>
      Français
    </button>
    <button (click)="setLanguage('it')" mat-menu-item>
      Italiano
    </button>
  </mat-menu>
</div>

<mat-nav-list appAccordion>

  <mat-list-item
    *ngFor="let menuitem of menuItems.allowedMenuItems()"
    appAccordionLink
    group="{{ menuitem.state }}"
    routerLinkActive="selected">

    <!--  Simple Parent -->
    <a
      *ngIf="menuitem.type === 'link'"
      [routerLink]="['/', menuitem.state]"
      appAccordionToggle
      class="">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name | translate }}</span>
    </a>

    <!--  Parent with children -->
    <a *ngIf="menuitem.type === 'sub'"
       [routerLink]="['/', menuitem.state]"
       appAccordionToggle
       class="">
      <mat-icon
        *ngIf="menuitem.icon !== undefined && menuitem.icon !== ''">
        {{ menuitem.icon }}
      </mat-icon>
      <span>{{ menuitem.name | translate }}</span>
      <mat-icon class="dd-icon" class="push-right">keyboard_arrow_down</mat-icon>
    </a>

    <!--  Children -->
    <mat-nav-list
      *ngIf="menuitem.type === 'sub'"
      class="sub-item">
      <mat-list-item
        *ngFor="let childitem of menuitem.children"
        routerLinkActive="selected">
        <a
          *ngIf="childitem.type === 'link'"
          [routerLink]="['/', menuitem.state, childitem.state]"
          class="relative"
          routerLinkActive="selected">
          <mat-icon
            *ngIf="childitem.icon !== undefined && childitem.icon !== ''">
            {{ childitem.icon }}
          </mat-icon>
          <span>{{ childitem.name | translate }}</span>
        </a>
      </mat-list-item>
    </mat-nav-list>

    <div *ngIf="menuitem.type === 'separator'" class="saperator text-muted">
      <span>{{ menuitem.name }}</span>
    </div>
  </mat-list-item>
</mat-nav-list>
